<template>
    <div class="c-row">
        <div class="c-tr">
            <div class="c-td is-1">
                <div
                    v-if="deviceDuringResignation"
                    class="d-flex align-items-start pb-1"
                >
                    <a-icon class="mr-1 text-warning" :icon="'Warning'" />
                    <strong v-text="'W trakcie wypowiedzenia'" />
                </div>

                <p class="mb-1 text-break" v-text="data.rad_id" />
                <p class="text-body mb-0" v-text="data.name" />
            </div>

            <div class="c-td is-10">
                <span class="typo-label" v-text="'Oprogramowanie kasy'" />
                <p class="mb-1" v-text="data.producer_name" />
                <p class="text-body mb-0" v-text="data.firmware_version" />
            </div>

            <div class="c-tw w-paragons">
                <div class="c-td is-2">
                    <div class="pb-lg-0 pb-2">
                        <div
                            v-tooltip="tooltips.receipts"
                            class="d-flex justify-content-center align-items-center"
                        >
                            <span class="typo-label" v-text="'Paragony'" />
                            <a-icon class="typo-label icon" icon="Info" />
                        </div>
                        {{ data.receipt_count ? data.receipt_count : '-' }}
                    </div>

                    <div class="d-lg-none d-block">
                        <span class="typo-label" v-text="'Ostatni paragon'" />
                        <span>{{
                            data.last_receipt_date
                                ? $moment(data.last_receipt_date).format(
                                    'DD-MM-YYYY HH:mm:ss'
                                )
                                : '-'
                        }}</span>
                    </div>
                </div>
                <div class="c-td is-3 d-lg-block d-none">
                    <span class="typo-label">Ostatni paragon</span>
                    <span>{{
                        data.last_receipt_date
                            ? $moment(data.last_receipt_date).format(
                                'DD-MM-YYYY HH:mm:ss'
                            )
                            : '-'
                    }}</span>
                </div>
                <div class="c-td is-4">
                    <div
                        v-tooltip="tooltips.receiptStatus"
                        class="d-flex justify-content-center align-items-center"
                    >
                        <span class="typo-label">Status paragonów</span>
                        <a-icon class="typo-label icon" icon="Info" />
                    </div>

                    <status
                        :active="deviceActive"
                        :state="data.receipt_status"
                    />
                </div>
            </div>
            <div class="c-tw w-connection">
                <div class="c-td is-5">
                    <div
                        v-tooltip="tooltips.promotionUsage"
                        class="d-flex justify-content-center align-items-center"
                    >
                        <span class="typo-label">Użycia promocji</span>
                        <a-icon class="typo-label icon" icon="Info" />
                    </div>

                    {{ data.number_of_usages ? data.number_of_usages : '-' }}
                </div>
                <div class="c-td is-6">
                    <div
                        v-tooltip="tooltips.usageState"
                        class="d-flex justify-content-center align-items-center align-items-center"
                    >
                        <span class="typo-label">Status użyć</span><a-icon class="typo-label icon" icon="Info" />
                    </div>

                    <status :active="deviceActive" :state="data.usage_status" />
                </div>
            </div>
            <div class="c-tw w-rest">
                <div class="c-td is-7">
                    <span class="typo-label">Ostatnie połączenie</span>
                    <span>{{
                        data.last_heartbeat_date
                            ? $moment(data.last_heartbeat_date).format(
                                'DD-MM-YYYY HH:mm:ss'
                            )
                            : ''
                    }}</span>
                </div>
                <div class="c-td is-8">
                    <div
                        v-tooltip="tooltips.connectionStatus"
                        class="d-flex justify-content-center align-items-center"
                    >
                        <span class="typo-label">Status połączeń</span><a-icon class="typo-label icon" icon="Info" />
                    </div>

                    <status
                        :active="deviceActive"
                        :state="data.heartbeat_status"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Status from '@/components/reports/diagnostics/Status.vue'

export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        tooltips() {
            return this.$store.getters.getDiagnosticsTooltips
        },
        deviceActive() {
            return this.data.state.code === 'ACTIVE'
        },
        deviceDuringResignation() {
            return this.data.state.code === 'DURING_RESIGNATION'
        }
    },
    components: {
        Status
    }
}
</script>
